export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Lab-as-a-Service",
  list: [
    {
      label: "Cost-Effective",
      text: "Reduces operational costs by eliminating the need for physical lab infrastructure.",
    },
    {
      label: "Scalability",
      text: "Users can scale their lab environments as per business needs without hardware limitations.",
    },
    {
      label: "Flexible Testing",
      text: "Supports multiple configurations, making it ideal for network testing, software development, and certification training.",
    },
    {
      label: "User-Friendly Interface",
      text: "Simplifies the testing and learning process with an intuitive and easy-to-navigate platform.",
    },
    {
      label: "On-Demand Access",
      text: "Provides 24/7 availability, ensuring seamless learning and testing experiences.",
    },
    {
      label: "Security & Compliance",
      text: "Ensures data protection and compliance with industry standards.",
    },
    {
      label: "Multi-User Collaboration",
      text: "Enables teams to work on shared lab environments for enhanced productivity.",
    },
  ],
};
